import { AgGridReact } from "ag-grid-react";
import React, { useCallback, useRef, useState } from "react";
import { Pagination } from "../../components";

import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { formateDatabuyCurr } from "../../utils/types";


interface jsPDFCustom extends jsPDF {
    autoTable: (options: UserOptions) => void;
  }

//typescript interface?

interface executeDataPrototypes {
  selectedDate: string;
  getExecuteValue: any;
  sectorCount:any;
  SectorpageHandler:any;
  SectorCurrentPage:any;
  selectedId:any;
}

export interface TaskData {
    symbol: string;
    date: any;
    cost: any;
    gainOrLoss: number;
    marketValue: number;
    price: number;
    qty:any
  }

const TableData = (props: executeDataPrototypes) => {
    const dataGridRefMain = useRef<AgGridReact<TaskData>>(null);
  const [columns, setColumns] = useState([
    {
      headerName: "Symbol",
      field: "symbol",
      flex: 1,
      filter: "agTextColumnFilter",
      floatingFilter: true,
    },
    {
      headerName: "Date",
      field: "date",
      width:150,
      filter: "agDateColumnFilter",
      floatingFilter: true,
      cellClass: "cell-wrap-text",
    cellRenderer: (p: any) => {
      return new Date(p.value).toLocaleDateString();
    },
    },
    {
      headerName: "Cost",
      field: "cost",
      width:120,
      filter: "agTextColumnFilter",
      cellRenderer: formateDatabuyCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Gain / Loss",
      field: "gainOrLoss",
      filter: "agNumberColumnFilter",
      cellRenderer: formateDatabuyCurr,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Market Value",
      field: "marketValue",
      width: 120,
      filter: "agNumberColumnFilter",
      cellRenderer: formateDatabuyCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Price",
      field: "price",
      width: 120,
      filter: "agNumberColumnFilter",
      cellRenderer: formateDatabuyCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Qty",
      field: "qty",
      width: 120,
      filter: "agNumberColumnFilter",
    },
  ]);

  const onBtExportMain = useCallback(() => {
    dataGridRefMain.current!.api.exportDataAsExcel();
  }, []);

  const exportPDFData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Task Details";
    const headers = [
      [
        "Symbol",
        "Date",
        "Cost",
        "GainOrLoss",
        "MarketValue",
        "Price",
        "Qty",
      ],
    ];

    const data = props?.getExecuteValue.map((e: any) => [
      e.symbol,
      e.date,
      e.cost,
      e.gainOrLoss,
      e.marketValue,
      e.price,
      e.qty
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("TaskDetails.pdf");
  };

  return (
    <div>
    
            
        <div className="col-12 col-md-12 col-xxl-12  mt-4">
             <div className="card-header w-100 px-0">
            <h5 className="card-title d-inline-block">Task Details</h5>
            <div className="d-inline-block col-sm-3 float-end">
             
              <div className="col-sm-12 my-3 text-end">
                <i
                  className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                  style={{ fontSize: "16px" }}
                  onClick={onBtExportMain}
                ></i>
                <i
                  className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                  onClick={() => exportPDFData()}
                  style={{ fontSize: "16px" }}
                ></i>
              </div>
            </div>
          </div>
          <div className="card-body w-100 px-0">
            <div className="chart chart-xs">
              <div className="chartjs-size-monitor">
                <div className="chartjs-size-monitor-shrink">
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                    ref={dataGridRefMain}
                      rowData={props?.getExecuteValue}
                      columnDefs={columns}
                      animateRows={true}
                      rowHeight={40}
                      pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                    ></AgGridReact>
                  </div>
               
                </div>
              </div>
            </div>
          </div>
          </div>
    
    </div>
  );
};

export { TableData };
